import React, { useState } from "react";
import { tradeUpload } from "../../utils/tradeApi";

export default function TradeUploadModal({ projectId, category, onClose, onUploaded }) {
  const [file, setFile] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [drawingCompany, setDrawingCompany] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  function chooseFile(event) {
    const selected = event.target.files?.[0] || null;
    setFile(selected);
    if (selected && !displayName) setDisplayName(selected.name.replace(/\.[^.]+$/, ""));
  }

  async function submit(event) {
    event.preventDefault();
    setError("");
    if (!file) return setError("Choose a PDF, DWG, or ZIP file.");
    const extension = file.name.split(".").pop().toLowerCase();
    if (!["pdf", "dwg", "zip"].includes(extension)) return setError("Only PDF, DWG, and ZIP files are supported.");
    setSaving(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("projectId", projectId);
      formData.append("categoryId", category._id);
      formData.append("displayName", displayName.trim());
      formData.append("issueDate", issueDate);
      formData.append("drawingCompany", drawingCompany.trim());
      const created = await tradeUpload("/api/trade/files", formData);
      onUploaded(created);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="trade-modal-backdrop" role="presentation">
      <section className="trade-modal" role="dialog" aria-modal="true" aria-labelledby="trade-upload-title">
        <header><div><span className="trade-eyebrow trade-green">UPLOAD DRAWING</span><h2 id="trade-upload-title">{category.display_name || `${category.code} ${category.name}`}</h2></div><button onClick={onClose} aria-label="Close">×</button></header>
        <form className="trade-form" onSubmit={submit}>
          <label>File <input type="file" accept=".pdf,.dwg,.zip" onChange={chooseFile} required /></label>
          <label>Display name <input value={displayName} onChange={(event) => setDisplayName(event.target.value)} required /></label>
          <div className="trade-form-row">
            <label>Issue date <input type="date" value={issueDate} onChange={(event) => setIssueDate(event.target.value)} required /></label>
            <label>Drawing company <input value={drawingCompany} onChange={(event) => setDrawingCompany(event.target.value)} required /></label>
          </div>
          {error && <div className="trade-alert error">{error}</div>}
          <footer><button type="button" className="trade-button secondary" onClick={onClose}>Cancel</button><button className="trade-button primary" disabled={saving}>{saving ? "Uploading…" : "Upload as pending"}</button></footer>
        </form>
      </section>
    </div>
  );
}
